import { ReactNode } from "react";
import MenuItem from "./menu-item";
import {
  DraftingCompass,
  FolderDot,
  GalleryHorizontal,
  LayoutDashboard,
  List,
  Plus,
  Settings,
  ShieldCheck,
  Truck,
  User,
} from "lucide-react";
import AdminOverview from "./admin-overview";
import LogoutRenderer from "@/components/shared/logout-renderer";
import { OrgButton } from "@/components/shared-ui";
import { WholePermissions } from "@/types/role";

export interface MenuItemType {
  label: string;
  children?: MenuItemType[];
  href?: string;
  permission?: string;
  icon?: ReactNode;
  count?: number;
  render?: (item: MenuItemType) => ReactNode;
}

const ICON_FONT_SIZE = 20;

const menuItems: MenuItemType[] = [
  { icon: <LayoutDashboard />, label: "داشبورد", href: "/dashboard" },
  {
    icon: <GalleryHorizontal size={ICON_FONT_SIZE} />,
    label: "اسلایدر خانه",
    permission: WholePermissions.GET_HOME_SLIDER,
    children: [
      {
        label: "افزودن",
        href: "/sliders/add",
        icon: <Plus size={ICON_FONT_SIZE} />,
        permission: WholePermissions.ADD_HOME_SLIDER,
      },
      {
        label: "لیست",
        href: "/sliders/list",
        icon: <List size={ICON_FONT_SIZE} />,
        permission: WholePermissions.GET_HOME_SLIDER,
      },
    ],
  },
  {
    icon: <FolderDot size={ICON_FONT_SIZE} />,
    label: "پروژه‌ها",
    permission: WholePermissions.GET_PROJECTS,
    children: [
      {
        label: "افزودن",
        href: "/projects/add",
        icon: <Plus size={ICON_FONT_SIZE} />,
        permission: WholePermissions.CREATE_PROJECT,
      },
      {
        label: "لیست",
        href: "/projects/list",
        icon: <List size={ICON_FONT_SIZE} />,
        permission: WholePermissions.GET_USERS,
      },
    ],
  },
  {
    icon: <DraftingCompass size={ICON_FONT_SIZE} />,
    label: "دیزاین‌ها",
    permission: WholePermissions.GET_DESIGNS,
    children: [
      {
        label: "افزودن",
        href: "/designs/add",
        icon: <Plus size={ICON_FONT_SIZE} />,
        permission: WholePermissions.CREATE_DESIGN,
      },
      {
        label: "لیست",
        href: "/designs/list",
        icon: <List size={ICON_FONT_SIZE} />,
        permission: WholePermissions.GET_DESIGNS,
      },
    ],
  },
  {
    icon: <ShieldCheck size={ICON_FONT_SIZE} />,
    label: "نقش‌ها",
    permission: WholePermissions.GET_ROLES,
    children: [
      {
        label: "افزودن",
        href: "/roles/add",
        icon: <Plus size={ICON_FONT_SIZE} />,
        permission: WholePermissions.EDIT_ROLE,
      },
      {
        label: "لیست",
        href: "/roles/list",
        icon: <List size={ICON_FONT_SIZE} />,
        permission: WholePermissions.EDIT_ROLE,
      },
    ],
  },
  {
    icon: <User size={ICON_FONT_SIZE} />,
    label: "کاربران",
    permission: WholePermissions.GET_USERS,
    children: [
      {
        label: "افزودن",
        href: "/users/add",
        icon: <Plus size={ICON_FONT_SIZE} />,
      },
      {
        label: "لیست",
        href: "/users/list",
        icon: <List size={ICON_FONT_SIZE} />,
        permission: WholePermissions.GET_USERS,
      },
    ],
  },
  {
    icon: <Settings size={ICON_FONT_SIZE} />,
    label: "تنظیمات",
    permission: WholePermissions.GET_SETTINGS,
    children: [
      {
        label: "لیست",
        href: "/settings/list",
        icon: <List size={ICON_FONT_SIZE} />,
        permission: WholePermissions.GET_SETTINGS,
      },
    ],
  },
  {
    label: "Logout",
    render: (item) => (
      <div className='mx-4 mt-4 mb-4'>
        <LogoutRenderer
          renderer={(open) => (
            <OrgButton variant={"outline"} onClick={open}>
              خروج از حساب کاربری
            </OrgButton>
          )}
        />
      </div>
    ),
  },
];

export default function Sidebar() {
  return (
    <aside className='w-64 border-l h-screen fixed overflow-y-auto'>
      <AdminOverview />
      <ul className='mt-4 flex flex-col'>
        {menuItems.map((item, key) => (
          <MenuItem {...item} key={key} />
        ))}
      </ul>
    </aside>
  );
}
